<template>
    <div style="width: 350px; margin: auto">
        <el-form size="small" align="center" label-position="left" status-icon :model="formData" :rules="rules" ref="formData" label-width="105px">
            <el-form-item align="left" label="Current device">
                <p>{{chooseItem.device_id.substring(7)}}</p>
            </el-form-item>
            <el-form-item prop="crafite_name" align="left" label="Trigger ID">
                <p>{{chooseItem.crafite_uuid.substring(2)}}</p>
            </el-form-item>
            <el-form-item prop="device_id" align="left" label="To Device ID">
                <el-input class="el-input--small" v-model="formData.device_id"></el-input>
            </el-form-item>

            <el-form-item align="right">
                <el-button class="el-button--small" @click="back()">Back</el-button>
                <el-button class="el-button--small el-button--primary" @click="submit('formData')">Save</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "icraftieUpdate",
    props: {
        closeUpdate: Function,
    },
    data() {
        return {
            rules: {
                device_id: [
                    {
                        required: true,
                        message: "Please enter change device ID!",
                        trigger: "blur",
                    },
                    { max: 9, min: 9, message: "The length of device ID must be 9!" },
                ],
            },
            formData:{
                device_id: ""
            },
            chooseItem: {},
        };
    },
    mounted() {
        this.chooseItem = this.$util.fetch("icraftiesUpdate");
        console.log(this.chooseItem);
    },
    methods: {
        submit(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$message.warning("Please check the input data!");
                    return
                }

                this.$confirm('Are you sure you want to transfer to another device?', 'prompt', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    const params = {
                        crafite_uuid: this.chooseItem.crafite_uuid,
                        current_device: this.chooseItem.device_id,
                        to_device: this.formData.device_id
                    }
                    let loading = this.$util.loading();
                    this.$api.rootV1.post(
                        "/web/craftie/icraftie/bindToOther",
                        params,
                        (res) => {
                            this.$alert("Successfully modified!", "info", {
                                confirmButtonText: "confirm",
                                type: "success",
                                callback: (action) => {
                                    loading.close();
                                },
                            });
                            this.$emit("closeUpdate");
                        },
                        (res) => {
                            this.$message.error(`fail! ${res.errmsg}`);
                            loading.close();
                        }
                    );
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'cancelled!'
                    })
                })
                
            });
        },
        back() {
            this.$emit("closeUpdate");
        },
    },
};
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 60px;
        color: #8c939d;
        width: 60px;
        height: 60px;
        line-height: 70px;
        text-align: left;
    }

    .avatar {
        width: 60px;
        height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/icraftieDataManage/icraftieUpdate.vue